import BackgroundImage from "../../../components/ui/BackgroundImage";
import clothingBg from "../assets/images/in-game.png";
import ClothingCategories from "./clothing-categories/ClothingCategories";
import ClothingHeader from "./ClothingHeader";
import OrderSummary from "./order-summary/OrderSummary";
import CATEGORIES, { DEFAULT_ACTIVE_CATEGORY } from "../constants/categories";
import CartProvider from "../providers/CartProvider";
import StoreProvider from "../providers/StoreProvider";
import ClothingList from "./clothing-list/ClothingList";
import EditProductModal from "./EditProductModal";
import CharacterRotation from "./CharacterRotation";

export interface ClothingStoreProps {
  className?: string;
  titleWords?: { text: string; isHighlighted?: boolean }[];
  description?: string;
}

const ClothingStore = ({
  className = "",
  titleWords = [{ text: "Clothing" }, { text: "Store", isHighlighted: true }],
  description = "A place where you can build your own style and flex it every day with your cool pants kek.",
}: ClothingStoreProps) => {
  return (
    <StoreProvider initialActiveCategory={DEFAULT_ACTIVE_CATEGORY}>
      <CartProvider>
        <BackgroundImage imageSrc={clothingBg} className="h-screen relative">
          <main
            className={`flex items-center justify-between w-full h-full p-10 gilroy-font  ${className}`}
          >
            {/** Categories */}
            <div className="flex flex-col justify-between space-y-5 h-full max-w-[370px]">
              <ClothingHeader
                titleWords={titleWords}
                description={description}
              />
              <ClothingCategories
                categories={CATEGORIES}
                className="flex-1 max-h-[70%] overflow-y-auto scrollbar-1 pr-2"
              />
              <OrderSummary />
              <CharacterRotation />
            </div>
            {/** CENTER */}
            <div></div>
            {/** ClothingList */}
            <div className="h-full flex flex-col overflow-hidden max-w-[380px] space-y-5">
              <ClothingHeader
                titleWords={[
                  { text: "List of" },
                  { text: "Clothes", isHighlighted: true },
                ]}
                description={
                  "A place where you can build your own style and flex it every day with your cool pants kek."
                }
                titleClassName="justify-end"
                className="text-right"
              />
              <ClothingList className="flex-1 min-h-0" />
            </div>
          </main>

          {/** ✅ Overlay */}
          <div className="absolute top-0 left-0 h-full w-[50%] bg-gradient-to-r from-black/60 to-transparent z-[-1]"></div>
          {/** IF YOU WANT BOTH SIDES TO HAVE OVERLAY, REPLACE DIV WITH THIS: */}
          {/**   <div className="absolute top-0 left-0 h-full w-[100%] bg-gradient-to-r from-black/65 via-transparent to-black/65 z-[-1]"></div> */}
        </BackgroundImage>

        {/** EDIT PRODUCT MDOAL - TRIGGERS AUTOMATICALY WHEN THERE'S MODAL INFO INSIDE STORE PROVIDER */}
        <EditProductModal />
      </CartProvider>
    </StoreProvider>
  );
};

export default ClothingStore;
